module.exports = __webpack_public_path__ + "img/k5.4b929650.png";